import React from "react";
import {Typography} from "@mui/material";
export default function FieldCounter(props) {
    return (
        <React.Fragment>
            <Typography
                style={{direction:"ltr",textAlign:"right",marginTop:5}}
                color={props.length > props.max ? "error" : "text"}
                variant="body2"
            >
                {props.length}<span className={props.length <= props.max ? "disabled-text" : null}>/{props.max}</span>
            </Typography>
        </React.Fragment>
    );
}